import React from "react";
import { useMeetingRecording } from "../../context/MeetingContext";

/**
 * Live-recording marker for the sidebar's Meetings entry.
 *
 * Closing the meetings modal leaves the recording running (the recorder
 * lives in MeetingContext at the app root), so something OUTSIDE the
 * modal has to say the mic is still live.
 *
 * Kept as its own component on purpose: it subscribes to the recording
 * context, which re-renders every second while the duration ticks, so
 * the sidebar itself doesn't re-render with it.
 */
const MeetingRecordingDot: React.FC = () => {
    const { recordingState } = useMeetingRecording();

    if (recordingState === 'idle') return null;

    const paused = recordingState === 'paused';
    const label = paused ? 'Recording paused' : 'Recording in progress';

    return (
        <span
            role="status"
            aria-label={label}
            title={label}
            className="relative flex h-2.5 w-2.5 flex-shrink-0"
        >
            {recordingState === 'recording' && (
                <span className="absolute inline-flex h-full w-full rounded-full bg-red-400 opacity-75 animate-ping" />
            )}
            <span
                className={`relative inline-flex h-2.5 w-2.5 rounded-full ${paused ? 'bg-amber-500' : 'bg-red-500'
                    }`}
            />
        </span>
    );
};

export default MeetingRecordingDot;
